module.exports = __webpack_public_path__ + "static/media/search_darkbleu.896c4881.svg";